import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-content-container" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = { class: "date-container" }
const _hoisted_7 = {
  key: 0,
  class: "dateInputWrap"
}
const _hoisted_8 = {
  key: 1,
  class: "dateInputWrap"
}
const _hoisted_9 = {
  key: 1,
  class: "date-container"
}
const _hoisted_10 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DropDownMultiple = _resolveComponent("DropDownMultiple")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.cancel }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('download.selection.modal.header')) + " ", 1),
            _createElementVNode("img", {
              src: _ctx.closeIcon,
              alt: "close",
              class: "close-icon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, null, 8, _hoisted_3)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.nbDocumentsModal > 100)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('download.selection.modal.nombre.important')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.filter.documentDateFrom !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_DatePicker, {
                    dateMax: _ctx.filter.documentDateTo,
                    dateValue: _ctx.filter.documentDateFrom,
                    label: _ctx.$t('label.documentDateFrom'),
                    onSetDate: _ctx.setDateFrom
                  }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.filter.documentDateTo !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_DatePicker, {
                    dateMin: _ctx.filter.documentDateFrom,
                    dateValue: _ctx.filter.documentDateTo,
                    label: _ctx.$t('label.documentDateTo'),
                    onSetDate: _ctx.setDateTo
                  }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.documentTypeList !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_DropDownMultiple, {
                  checkboxDisplay: this.documentTypeCheckboxDisplay,
                  inputDisplay: this.filterDocumentTypeDisplay,
                  isChecked: this.isCheckedDocumentType,
                  label: _ctx.$t('label.byDocumentType'),
                  list: _ctx.documentTypeList,
                  listTotal: _ctx.documentTypeList,
                  selectedItems: _ctx.filter.documentTypeList,
                  onAdd: _ctx.addSelectDocumentType,
                  onRemove: _ctx.removeSelectDocumentType,
                  onToggleSelectAll: _ctx.toggleSelectAll
                }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "listTotal", "selectedItems", "onAdd", "onRemove", "onToggleSelectAll"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ButtonBlue, {
              disabled: _ctx.isMissingData,
              onClick: _ctx.valider,
              text: _ctx.$t('download.selection.modal.button.valider'),
              class: "button-confirm-download",
              name: "confirm"
            }, null, 8, ["disabled", "onClick", "text"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}